<template>
    <div>


        <table class="table pricelist table-hover">
            <thead>
                <tr class="subrow">
                    <th>Saison</th>
                    <th class="text-center">Preis für die 1. Nacht*
                        <br/><small>inkl. einmaliger Endreinigung <br/>und CO2 Abgabe zzgl. Kurtaxe</small> </th>
                    <th class="text-center">ab der 2. Nacht*
                        <br/><small>Preis/Nacht zzgl. Kurtaxe</small></th>

                </tr>
            </thead>
            <tbody>
                <!--    <tr class="mainrow">
                <td colspan="3">
                        Miete
                    </td>
                </tr>-->
            </tbody>
            <tbody v-for="sg in priceArray">
                <tr v-for="price in sg.lines"
                    v-if="sg.service.type == 'RENT'"
                    class="subrow">
                    <td class="subinfo">
                        <small>{{price.season}}</small>
                        <br/>
                        <span v-if="price.fromdate">{{getFormattedDate(price.fromdate)}} - {{getFormattedDate(price.tilldate)}}</span>
                    </td>
                    <td class="text-center">
                        <!--  <span>ab {{getFirstNightPrice(price.value)}}</span>-->
                        <span>{{getFirstNightPrice(price.value)}}</span>
                    </td>
                    <td class="text-center">
                        <!--  <span>ab {{getCalculatedPrice(price.value)}}</span>-->
                        <span>{{getCalculatedPrice(price.value)}}</span>
                    </td>
                    <!--<td>
                        <span v-if="sg.service.type == 'RENT' && sg.nightRange && sg.nightRange.min">
												{{sg.nightRange.min}} Nächte
  										  </span>
                    </td>-->

                </tr>
            </tbody>
        </table>


    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'seasonprices',
    	props: {
    		pricelist: String
    	},
    	data: function() {
    		return {
    			priceArray: {},
    			unitId: Number,
    			priceBookingFee: Number,
    			priceFinalCleaning: Number,
    			priceHeatingFee: Number,

    		};
    	},
    	mounted: function() {
    		var pricelist = JSON.parse(this.pricelist);
    		this.priceArray = pricelist;

    		//console.log('Pricelist::', pricelist);
    		var years = [];
    		this.priceBookingFee = 0;
    		this.priceFinalCleaning = 0;
    		this.priceHeatingFee = 0;
    		var i, j;
    		for (i = 0; i < pricelist.length; i++) {
    			if (pricelist[i].service.type && pricelist[i].service.type === 'FINALCLEANING') {
    				this.priceFinalCleaning = pricelist[i].price;
    			}
    			if (pricelist[i].service.type && pricelist[i].service.type === 'BOOKING_FEE') {
    				this.priceBookingFee = pricelist[i].price;
    			}
    			if (pricelist[i].service.type && pricelist[i].service.type === 'HEATING') {
    				this.priceHeatingFee = pricelist[i].price;
    			}
    			for (j = 0; j < pricelist[i].lines.length; j++) {
    				//console.log('inside loop date::' + pricelist[i].lines[j].fromdate);
    				if (pricelist[i].lines[j].fromdate) {
    					var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    					//console.log('year is::' + year);
    					if (years.indexOf(year) < 0) {
    						years.push(year);
    					}
    				}
    			}
    		}
    		//	console.log('years::' + years);
    		/*console.log('this.pricelist::' + this.pricelist); */
    	},
    	methods: {
    		getYearButtonId: function(year) {
    			return 't' + year + '-tab';
    		},
    		getTarget: function(year) {
    			return "#t" + year;
    		},
    		getTabId: function(year) {
    			return "t" + year;
    		},
    		getTabAreaLabel: function(year) {
    			return "t" + year + "-tab";
    		},
    		getFormattedDate: function(date) {
    			return DateEx.formatDate(date, 'dd.MM.yy', 'de');
    		},
    		getFirstNightPrice: function(price) {
    			var rentPrice = price;
    			var calcPrice = 0;
    			if (price > 0) {
    				console.log("this.priceBookingFee:::" + this.priceBookingFee);

    				var totalPrice = rentPrice + this.priceFinalCleaning + this.priceBookingFee + this.priceHeatingFee;
    				calcPrice = Number((totalPrice) / 100).toLocaleString("de-DE", {
    					minimumFractionDigits: 2
    				}) + " €";
    			}
    			return calcPrice;
    		},
    		getCalculatedPrice: function(price) {
    			var rentPrice = 0;
    			var calcPrice = 0;
    			if (price > 0) {
    				calcPrice = Number((price) / 100).toLocaleString("de-DE", {
    					minimumFractionDigits: 2
    				}) + " € ";
    			}
    			return calcPrice;
    		},
    		isDateInRange: function(fromdate, year) {
    			if (!fromdate) {
    				return true;
    			}
    			var fromYear = parseInt(fromdate.substring(0, 4));
    			if (fromYear == year) {
    				return true;
    			}
    			return false;
    		}

    	},
    	computed: {
    		getYears: function() {
    			var pricelist = JSON.parse(this.pricelist);

    			console.log('Pricelist::', pricelist);
    			var years = [];

    			var i, j;
    			for (i = 0; i < pricelist.length; i++) {
    				for (j = 0; j < pricelist[i].lines.length; j++) {
    					if (pricelist[i].lines[j].fromdate) {
    						var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    						if (years.indexOf(year) < 0) {
    							years.push(year);
    						}
    					}
    				}
    			}
    			return years;
    		}
    	}
    };
</script>